export default "__VITE_PUBLIC_ASSET__63757136__"